
// TODO: Convert all images to webp
export const Image1 = "https://images.pexels.com/photos/7959763/pexels-photo-7959763.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
export const Image2 = "https://images.pexels.com/photos/8485714/pexels-photo-8485714.jpeg";
export const Image3 = "https://images.pexels.com/photos/6702633/pexels-photo-6702633.jpeg";
export const RetainerImage = "https://images.pexels.com/photos/4050081/pexels-photo-4050081.jpeg";


export const WomanWorking = "https://images.pexels.com/photos/8279518/pexels-photo-8279518.jpeg";




export { default as PencilWriteIcon } from "./icons/pencil_write_icon.svg"
export { default as VerticalTabsIcon } from "./icons/veritcal_tabs_icon.svg"
export { default as PhoneAndDesktopIcon } from "./icons/phone-and-desktop-icon.svg"
export { default as TabGroupIcon } from "./icons/tab-group-icon.svg"


export { default as GooglePartner } from "./accolade-icons/Google-Partner-Premier-2025.svg"
export { default as MetaPartner } from "./accolade-icons/Meta-Business-Partner-2026.svg"
export { default as HubspotPartner } from "./accolade-icons/Hubspot-Certified-Partner-2026.svg"
export { default as KlaviyoPartner } from "./accolade-icons/Klaviyo-Master-Champion-2026.svg"
export { default as MicrosoftPartner } from "./accolade-icons/Microsoft-Advertising-Partner-2025.svg"